import { pick } from 'ramda';
import { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';
import { useAppSelector } from 'js/store/hooks';

export const useIsPageInPopupUrl = () => {
    const {
        pageInPopupUrls,
        quickDepositPage,
        quickDepositUseCustom,
        gamesGridViewMorePageURL,
        gamesGridGameInfoPageURL,
        promotionInfoPageURL
    } = useAppSelector(pick([
        'pageInPopupUrls',
        'quickDepositPage',
        'quickDepositUseCustom',
        'gamesGridViewMorePageURL',
        'gamesGridGameInfoPageURL',
        'promotionInfoPageURL'
    ]));

    return useCallback(() => {
        // can't use useLocation here in order to BB compatibility
        const pathname = getCleanUrl(window.location.pathname);
        const isStaticPageInPopup = pathname.includes('/online-game/');
        const isGamesGridViewMorePage = pageInPopupUrls?.includes(gamesGridViewMorePageURL) && pathname.startsWith(`${gamesGridViewMorePageURL}/`);
        const isGamesGridInfoPage = pageInPopupUrls?.includes(gamesGridGameInfoPageURL) && pathname.startsWith(`${gamesGridGameInfoPageURL}/`);
        const isPromotionInfoPage = pageInPopupUrls?.includes(promotionInfoPageURL) && pathname.startsWith(`${promotionInfoPageURL}/`);

        return pageInPopupUrls?.includes(pathname)
            || pathname === quickDepositPage && !quickDepositUseCustom
            || isStaticPageInPopup
            || isGamesGridInfoPage
            || isGamesGridViewMorePage
            || isPromotionInfoPage;
    }, [
        pageInPopupUrls, quickDepositUseCustom, quickDepositPage,
        gamesGridViewMorePageURL, gamesGridGameInfoPageURL, promotionInfoPageURL
    ]);
};
